// Function used for limiting the input field of hourly pay rate to 2 decimals max
// Could be used on other fields where we need to limit the max ammout of decimals to 2
export const setNumberTo2DecimalsOnly = (value: string) => {
  // Regex that checks if the number has more than 2 decimals
  const hasMoreThanTwoDecimals = /^\d*(\.\d{3,})?$/

  if (hasMoreThanTwoDecimals.test(value)) {
    // Slice the string so we get the first 5 characters, 2 digits, a dot, 2 more digits(the decimals)
    const changedValue = value.slice(0, 5)
    return changedValue
  }
  return value
}

export const numberToOrdinalWord = (n: number): string => {
  const ordinals: { [key: number]: string } = {
    1: 'First',
    2: 'Second',
    3: 'Third',
    4: 'Fourth',
    5: 'Fifth',
    6: 'Sixth',
    7: 'Seventh',
    8: 'Eighth',
    9: 'Ninth',
    10: 'Tenth',
    11: 'Eleventh',
    12: 'Twelfth',
    13: 'Thirteenth',
    14: 'Fourteenth',
    15: 'Fifteenth',
    16: 'Sixteenth',
    17: 'Seventeenth',
    18: 'Eighteenth',
    19: 'Nineteenth',
    20: 'Twentieth',
  }

  if (ordinals[n]) return ordinals[n]

  if (n < 100) {
    const tens = Math.floor(n / 10) * 10
    const ones = n % 10

    const tensWords: { [key: number]: string } = {
      20: 'Twentieth',
      30: 'Thirtieth',
      40: 'Fortieth',
      50: 'Fiftieth',
      60: 'Sixtieth',
      70: 'Seventieth',
      80: 'Eightieth',
      90: 'Ninetieth',
    }

    const tensPrefix: { [key: number]: string } = {
      20: 'Twenty',
      30: 'Thirty',
      40: 'Forty',
      50: 'Fifty',
      60: 'Sixty',
      70: 'Seventy',
      80: 'Eighty',
      90: 'Ninety',
    }

    if (ones === 0) return tensWords[tens]
    return `${tensPrefix[tens]}-${ordinals[ones]}`
  }

  return `${n}th` // fallback for numbers 100+
}
